import { RefObject, useEffect } from 'react';

export const useSafariDragFix = (svgRef: RefObject<SVGSVGElement>) => {
  useEffect(() => {
    const svgElement = svgRef.current;

    const listener = (event: TouchEvent) => event.preventDefault();

    if (svgElement) {
      svgElement.addEventListener('touchmove', listener, {
        passive: false,
      });
    }

    return () => {
      if (svgElement) {
        svgElement.removeEventListener('touchmove', listener);
      }
    };
  }, []);
};
